





















































































































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import DateFormat from '@/shared/utils/date-format';
import { VMoney } from 'v-money';
import MainButton from '@/shared/buttons/main-button.component.vue';
import CalculationErrorFilter from '@/domain/calculation/entity/calculation-error-filter.entity';
import CalculationError from '@/domain/calculation/entity/calculation-error.entity';
import CustomerPickerComponent from '@/shared/customer-picker/customer-picker.component.vue';
import VueToExcel from 'vue-json-excel';

@Component({
  components: { MainButton, CustomerPickerComponent, VueToExcel },
  directives: { money: VMoney },
})
export default class CalculationErrorFilterComponent extends Vue {
  @Prop({
    required: true,
    default: '',
  })
  private businessUnitId!: string;

  @Prop({
    required: false,
  })
  private incomingFilter?: CalculationErrorFilter;

  @Prop({
    required: false,
    default: CalculationErrorFilter.of({}),
  })
  private errors!: CalculationError[];

  locale = 'pt-BR';

  filter: CalculationErrorFilter = CalculationErrorFilter.of({});

  ref: any = this.$refs;

  selectedCompetenceDate: string = '';

  lastFilteredName: string = '';

  netValueKey: number = 0;

  selectedDate: string = '';

  @Watch('errors')
  updateRecentErrorState() {
    this.filter.recentErrors = this.incomingFilter!.recentErrors
  }

  @Watch('incomingFilter')
  updateFilter() {
    if (this.incomingFilter && this.incomingFilter.competence) {
      this.selectedCompetenceDate = DateFormat.localToDate(this.incomingFilter.competence);
    }
  }

  private formatDate(date: string): string {
    if (date) {
      return DateFormat.timestampToLocal(date);
    }
    return '';
  }

  get dateText() {
    return this.formatDate(this.selectedDate);
  }

  send() {
    if (this.selectedCompetenceDate) {
      this.filter.competence = DateFormat.localDateToLocal(this.selectedCompetenceDate);
    }
    if (this.selectedDate) {
      this.filter.date = DateFormat.timestampToLocal(this.selectedDate)
    }
    this.$emit('filter', this.filter);
  }

  clear() {
    this.ref.form.reset();
    this.filter = new CalculationErrorFilter({});
    this.selectedCompetenceDate = '';
    this.selectedDate = '';
  }

  get competenceDateText() {
    return DateFormat.fullMonthAndYear(DateFormat.localDateToLocal(this.selectedCompetenceDate));
  }

  csvLabel = {
    'ID Contrato': 'externalId',
    'N. Contrato': 'contractNumber',
    Item: 'itemNumber',
    Cliente: 'customerName',
    Data: 'createdDate',
    'Mensagem de erro': 'message',
    Erro: 'error',
  }

  created(): void {
    this.updateFilter();
  }
}
